import React, { useEffect, useState } from "react";
import MUIDataTable from "mui-datatables";

import useDocumentTitle from "../../assets/utils/useDocumentTitle";
import { Breadcrumb, Footer, Header} from "../../components";
import BaseURL from "../../assets/utils/baseUrl";

function Cektunggakan() {
  useDocumentTitle("Cek Tunggakan PBB - BAPENDA BEKASI");

  // ... (state dan useEffect laporan tetap ada jika masih dibutuhkan di halaman lain)

  return (
    <div className="page">
      <Header active="Cektunggakan" />

      {/* main */}
      <main className="main-sb">
        <section className="content">
          <Breadcrumb path="Cek Tunggakan PBB" />
          
          <div className="page-title-wrapper">
            <div className="page-title">Info Tunggakan</div>
          </div>

          {/* Menampilkan Website Luar di dalam Iframe */}
          <div style={{ width: '100%', overflow: 'hidden', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0,0,0,0.1)' }}>
            <iframe
              src="https://e-pbb.bekasikota.go.id/info_pbb.php"
              title="Cek Tunggakan PBB"
              style={{
                width: '100%',
                height: '800px', // Atur tinggi sesuai kebutuhan
                border: 'none'
              }}
              allowFullScreen
            ></iframe>
          </div>

        </section>
 
      </main>

      <Footer />
    </div>
  );
}

export default Cektunggakan;